<template>
  <!-- 官网整体骨架：顶部导航 + 页面内容 + 底部信息 -->
  <div id="app">
    <site-header :site-name="config.site_name" :logo="config.logo" />
    <main class="site-main">
      <!-- 各个页面（首页 / 新闻 / 产品 / 关于我们）在这里渲染 -->
      <router-view />
    </main>
    <site-footer :config="config" />
  </div>
</template>

<script>
import SiteHeader from './components/SiteHeader.vue'
import SiteFooter from './components/SiteFooter.vue'
import { getSiteConfig } from './api'

export default {
  name: 'App',
  // 公共组件：整站每个页面都用得到，所以放在 App 里
  components: { SiteHeader, SiteFooter },
  data() {
    return {
      // 站点配置：名称 / 浏览器标题 / 联系方式 / 备案号等，来自后台「站点配置」
      config: {
        site_name: '',
        logo: '',
        favicon: '',
        site_title: '',
        site_description: '',
        phone: '',
        email: '',
        address: '',
        icp: '',
        about_brief: ''
      }
    }
  },
  created() {
    this.loadConfig()
  },
  methods: {
    async loadConfig() {
      try {
        const res = await getSiteConfig()
        this.config = { ...this.config, ...res.data }
        // 浏览器标签页标题
        if (this.config.site_title) {
          document.title = this.config.site_title
        }
        // SEO 描述写到 meta[name=description]
        if (this.config.site_description) {
          const meta = document.querySelector('meta[name="description"]')
          if (meta) meta.setAttribute('content', this.config.site_description)
        }
        // 浏览器标签页图标：后台配置了 favicon 就替换默认图标
        if (this.config.favicon) {
          let link = document.querySelector('link[rel="icon"]')
          if (!link) {
            link = document.createElement('link')
            link.setAttribute('rel', 'icon')
            document.head.appendChild(link)
          }
          link.setAttribute('href', this.config.favicon)
        }
      } catch (e) {
        // 配置拉取失败不影响页面展示（Header/Footer 有兜底文字）
      }
    }
  }
}
</script>

<style>
/* ------------------------------------------------------------------
   全局基础样式（不加 scoped，作用于整个官网）
   ------------------------------------------------------------------ */
* { box-sizing: border-box; }
html, body { margin: 0; padding: 0; }
body {
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
  color: #303133;
  background: #f5f7fa;
}
a { text-decoration: none; color: inherit; }
img { display: block; }

#app { display: flex; flex-direction: column; min-height: 100vh; }
.site-main { flex: 1; }

/* 统一的内容容器：限制最大宽度并居中 */
.container { width: 1200px; max-width: 92%; margin: 0 auto; }

/* 各列表 / 详情页顶部的标题条 */
.page-hero {
  background: linear-gradient(135deg, #1a3a6b, #1677ff);
  color: #fff;
  padding: 46px 0;
}
.page-hero h1 { margin: 0; font-size: 26px; font-weight: 600; }
.page-hero p { margin: 8px 0 0; font-size: 14px; opacity: 0.85; }

/* 图片缺失时的占位块（不引用外部图片，纯 CSS 实现） */
.img-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
  background: #eef0f3;
  font-size: 13px;
}

/* 区块标题（首页各栏目、列表页通用） */
.section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}
.section-title {
  position: relative;
  margin: 0;
  padding-left: 14px;
  font-size: 22px;
  font-weight: 600;
  color: #1f2d3d;
}
/* 标题左侧的蓝色小竖条 */
.section-title::before {
  content: "";
  position: absolute;
  left: 0;
  top: 4px;
  bottom: 4px;
  width: 4px;
  border-radius: 2px;
  background: #1677ff;
}
.section-more { color: #909399; font-size: 14px; }
.section-more:hover { color: #1677ff; }
</style>
